import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { Button, Icon, Grid } from 'semantic-ui-react';
import CustomerSubscriptionModal from './Subscriptions/CustomerSubscriptionModal';
import MerchantSubscriptionModal from './Subscriptions/MerchantSubscriptionModal';
import Helper from '../helper';
import ExportData from './ExportData';
import HavePermission from './PermissionsService/HavePermission';

class HeaderContent extends Component {
    render() {
        const { pathname } = this.props.location;
        const testId = `components-title-${pathname.replace(/^\//, '').split('-').map((part, index) => {
        if (part === 'qr') return 'QR';
            return index === 0
            ? part.toLowerCase()
            : part.charAt(0).toUpperCase() + part.slice(1).toLowerCase();}).join('')}`;
            
        return (
            <Grid>
                <Grid.Column tablet={16} computer={6}>
                    <h2 data-testid={testId}>{pathname === '/customer-management' ? 'Customer Management' : Helper.titleCaseForTabs(pathname.substr(1).split("-").join(' '))}</h2>
                </Grid.Column>
                <Grid.Column tablet={16} computer={10} className="buttons-group-col">
                    <Button.Group size='mini'>
                        <ExportData />
                        {(pathname === '/customer-management') && (
                            <HavePermission for="customer.management.create.subscription">
                                <CustomerSubscriptionModal refreshHandler={this.props.onRefreshHandler} trigger={<Button icon primary labelPosition='left' data-testid="components-button-newSubscription">New Subscription<Icon name='plus' /></Button>} header='New Subscription' />
                            </HavePermission>)}
                        {(pathname === '/merchant-management') && (
                            <HavePermission for="merchant.management.create.subscription">
                                <MerchantSubscriptionModal refreshHandler={this.props.onRefreshHandler} trigger={<Button icon primary labelPosition='left' data-testid="components-button-newSubscriptionMerchant">New Subscription<Icon name='plus' /></Button>} header='New Subscription' />
                            </HavePermission>)}
                    </Button.Group>
                </Grid.Column>
            </Grid>
        );
    }
}

export default withRouter(HeaderContent);